
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire4b75"];
var parcelRegister = parcelRequire.register;
parcelRegister("cp7HX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "AllergensDisplay", function () { return $4b538c708a2d4799$export$90ecaeb671f361c9; });
$parcel$export(module.exports, "default", function () { return $4b538c708a2d4799$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $lp3dk = parcelRequire("lp3dk");

var $ghmTa = parcelRequire("ghmTa");
var $cGjF4 = parcelRequire("cGjF4");
var $3lzdj = parcelRequire("3lzdj");
var $jOOuf = parcelRequire("jOOuf");

var $jf2w9 = parcelRequire("jf2w9");

var $bEEBX = parcelRequire("bEEBX");

var $3xOZa = parcelRequire("3xOZa");

var $77puL = parcelRequire("77puL");

var $j6ChH = parcelRequire("j6ChH");

var $8kt8E = parcelRequire("8kt8E");

var $aRSTV = parcelRequire("aRSTV");

var $5OqMf = parcelRequire("5OqMf");

var $25aT1 = parcelRequire("25aT1");

var $bZiDo = parcelRequire("bZiDo");

var $3pORK = parcelRequire("3pORK");

var $kvAnV = parcelRequire("kvAnV");

var $9Vrue = parcelRequire("9Vrue");

var $fGZ1g = parcelRequire("fGZ1g");

var $eucAq = parcelRequire("eucAq");

var $3kQAm = parcelRequire("3kQAm");

var $9qb0n = parcelRequire("9qb0n");

var $4TXrN = parcelRequire("4TXrN");

var $18kth = parcelRequire("18kth");

var $4Ke1J = parcelRequire("4Ke1J");

var $2DkT2 = parcelRequire("2DkT2");
const $4b538c708a2d4799$export$90ecaeb671f361c9 = ({ product: product })=>{
    if ((0, $bEEBX.default)(product?.allergens) || (0, (/*@__PURE__*/$parcel$interopDefault($77puL)))(product.allergens)) return null;
    const parts = product.allergens.split(". ");
    return parts.map((part)=>/*#__PURE__*/ (0, $7YWoO.jsxs)("p", {
            children: [
                (0, $kvAnV.default)(part, "."),
                "."
            ]
        }, part));
};
const $4b538c708a2d4799$var$ProductDetailsPage = ({ slug: slug })=>{
    const urlKey = (0, $5OqMf.stripPossibleHtmlExtension)(slug);
    const product = (0, $bZiDo.default).findProductByUrlKey(urlKey);
    if (!(0, $bZiDo.default).productsLoaded) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9Vrue.default), {});
    if ((0, $3xOZa.default)(product)) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $fGZ1g.default), {});
    const catInfo = (0, $jf2w9.default)((0, $25aT1.default).findCategoryKeysBySku(product.sku).map((key)=>(0, $25aT1.default).findCategoryByUrlKey(key)));
    const breadcrumbItems = catInfo?.levels.map((c)=>({
            label: (0, $5OqMf.titleCase)(c.name),
            href: c.fullUrl,
            as: (0, $8kt8E.Link)
        })) || [];
    // Add product name to breadcrumb
    breadcrumbItems.length && breadcrumbItems.push({
        label: product.name,
        href: "",
        as: (0, $8kt8E.Link)
    });
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "print:tw-hidden tw-relative",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $j6ChH.Helmet), {
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)("title", {
                                children: product.name
                            }),
                            !!product.description && /*#__PURE__*/ (0, $7YWoO.jsx)("meta", {
                                name: "description",
                                content: product.description.toString()
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: "tw-mb-4",
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $ghmTa.Breadcrumbs), {
                            items: breadcrumbItems
                        })
                    }),
                    product.expired ? /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9qb0n.default), {
                        product: product
                    }) : /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $eucAq.default), {
                                className: "tw-py-12",
                                children: [
                                    /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $3lzdj.Grid), {
                                        cols: 12,
                                        gap: {
                                            base: 2,
                                            lg: 8
                                        },
                                        className: "tw-relative tw-pb-6",
                                        children: [
                                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                                className: "tw-absolute tw-top-0 tw-right-0 tw-z-20 tw-hidden lg:tw-block",
                                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                                                    size: "compact",
                                                    onClick: ()=>window.print(),
                                                    variant: "tertiary",
                                                    icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3pORK.default), {}),
                                                    children: "Skriv ut produktdatablad"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3lzdj.Grid).Col, {
                                                span: {
                                                    base: 12,
                                                    lg: 4
                                                },
                                                className: "tw-relative",
                                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $18kth.default), {
                                                    product: product
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3lzdj.Grid).Col, {
                                                span: {
                                                    base: 12,
                                                    lg: 8
                                                },
                                                className: "tw-pb-6 tw-relative",
                                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4Ke1J.default), {
                                                    product: product
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4TXrN.default), {
                                        product: product
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "lg:tw-hidden tw-py-5",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                                    size: "compact",
                                    onClick: ()=>window.print(),
                                    variant: "secondary",
                                    icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3pORK.default), {}),
                                    children: "Skriv ut produktdatablad"
                                })
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $jOOuf.Group), {
                                justify: "start",
                                className: "tw-mt-6 tw-border-ink-border-subtle",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3kQAm.default), {
                                    skus: product.similarProducts,
                                    listName: "Andre anbefalte produkter",
                                    heading: "Andre anbefalte produkter",
                                    listType: (0, $aRSTV.LIST_TYPE).RECOMMENDATIONS,
                                    context: "recommendations",
                                    count: 6
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $2DkT2.default), {
                product: product
            })
        ]
    });
};
var $4b538c708a2d4799$export$2e2bcd8739ae039 = (0, $lp3dk.view)($4b538c708a2d4799$var$ProductDetailsPage);

});
parcelRegister("3pORK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27cb29cc7b877a5d$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $27cb29cc7b877a5d$var$SvgPrint = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M16.5 8.143V4.929h-9v3.214H5.571V3H18.43v5.143zm1.602 4.5a.95.95 0 0 0 .688-.276.92.92 0 0 0 .281-.683.95.95 0 0 0-.275-.688.92.92 0 0 0-.683-.282.95.95 0 0 0-.689.276.92.92 0 0 0-.281.683q0 .407.276.689a.92.92 0 0 0 .683.28M16.5 19.07v-3.857h-9v3.857zM18.429 21H5.57v-3.857H1.714v-9h20.572v9h-3.857zm1.955-5.786v-5.143H3.643v5.143H5.57v-1.928H18.43v1.928z"
        })
    }));
var $27cb29cc7b877a5d$export$2e2bcd8739ae039 = $27cb29cc7b877a5d$var$SvgPrint;

});

parcelRegister("kvAnV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eee2ed320e397782$export$2e2bcd8739ae039; });

var $jjUEx = parcelRequire("jjUEx");

var $6QJPP = parcelRequire("6QJPP");

var $htGWJ = parcelRequire("htGWJ");

var $fXIA9 = parcelRequire("fXIA9");

var $cQbRr = parcelRequire("cQbRr");

var $9n9Ks = parcelRequire("9n9Ks");
/**
 * Removes trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trimEnd('  abc  ');
 * // => '  abc'
 *
 * _.trimEnd('-_-abc-_-', '_-');
 * // => '-_-abc'
 */ function $eee2ed320e397782$var$trimEnd(string, chars, guard) {
    string = (0, $cQbRr.default)(string);
    if (string && (guard || chars === undefined)) return string.slice(0, (0, $9n9Ks.default)(string) + 1);
    if (!string || !(chars = (0, $jjUEx.default)(chars))) return string;
    var strSymbols = (0, $fXIA9.default)(string), end = (0, $htGWJ.default)(strSymbols, (0, $fXIA9.default)(chars)) + 1;
    return (0, $6QJPP.default)(strSymbols, 0, end).join("");
}
var $eee2ed320e397782$export$2e2bcd8739ae039 = $eee2ed320e397782$var$trimEnd;

});

parcelRegister("9qb0n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41622c744e7462e5$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $lp3dk = parcelRequire("lp3dk");

var $eYDe5 = parcelRequire("eYDe5");
var $cGjF4 = parcelRequire("cGjF4");
var $3lzdj = parcelRequire("3lzdj");
var $jOOuf = parcelRequire("jOOuf");

var $aRSTV = parcelRequire("aRSTV");

var $3pORK = parcelRequire("3pORK");

var $6fuyt = parcelRequire("6fuyt");

var $eucAq = parcelRequire("eucAq");

var $3kQAm = parcelRequire("3kQAm");

var $4TXrN = parcelRequire("4TXrN");

var $18kth = parcelRequire("18kth");

var $4Ke1J = parcelRequire("4Ke1J");
const $41622c744e7462e5$var$ExpiredProductDetails = ({ product: product })=>{
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $eucAq.default), {
                className: "tw-py-12",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $3lzdj.Grid), {
                        cols: 12,
                        gap: {
                            base: 2,
                            lg: 8
                        },
                        className: "tw-relative tw-pb-6",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "tw-absolute tw-top-0 tw-right-0 tw-z-20 tw-hidden lg:tw-block",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                                    size: "compact",
                                    onClick: ()=>window.print(),
                                    variant: "tertiary",
                                    icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3pORK.default), {}),
                                    children: "Skriv ut produktdatablad"
                                })
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3lzdj.Grid).Col, {
                                span: {
                                    base: 12,
                                    lg: 4
                                },
                                className: "tw-relative",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $18kth.default), {
                                    product: product
                                })
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3lzdj.Grid).Col, {
                                span: {
                                    base: 12,
                                    lg: 8
                                },
                                className: "tw-pb-6 tw-relative",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4Ke1J.default), {
                                    product: product
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $eYDe5.Accordion), {
                        label: "Vis produktinformasjon",
                        variant: "compact",
                        className: "tw-max-w-[1350px]",
                        onClick: ()=>(0, $6fuyt.sendAccordionClick)("Vis produktinformasjon (utg\xe5tt produkt)"),
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                            className: "tw-my-6",
                            children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4TXrN.default), {
                                product: product
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "lg:tw-hidden tw-py-4",
                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                    size: "compact",
                    onClick: ()=>window.print(),
                    variant: "secondary",
                    icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3pORK.default), {}),
                    children: "Skriv ut produktdatablad"
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $jOOuf.Group), {
                justify: "start",
                className: "tw-mt-6 tw-border-ink-border-subtle",
                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3kQAm.default), {
                    skus: product.newSkus && product.newSkus.length > 0 ? product.newSkus : product.similarProducts,
                    listName: "Erstatningsprodukter",
                    heading: product.newSkus?.length === 1 ? "Erstattes med" : "Andre anbefalte produkter",
                    listType: (0, $aRSTV.LIST_TYPE).RECOMMENDATIONS,
                    context: "recommendations",
                    count: 6
                })
            })
        ]
    });
};
var $41622c744e7462e5$export$2e2bcd8739ae039 = (0, $lp3dk.view)($41622c744e7462e5$var$ExpiredProductDetails);

});
parcelRegister("4TXrN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8324848bce55a33d$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $lp3dk = parcelRequire("lp3dk");

var $eYDe5 = parcelRequire("eYDe5");
var $3lzdj = parcelRequire("3lzdj");

var $77puL = parcelRequire("77puL");

var $5OqMf = parcelRequire("5OqMf");

var $gzL3Z = parcelRequire("gzL3Z");

var $agWqs = parcelRequire("agWqs");

var $dvPqk = parcelRequire("dvPqk");

var $6fuyt = parcelRequire("6fuyt");

var $1ucql = parcelRequire("1ucql");

var $cp7HX = parcelRequire("cp7HX");
const $8324848bce55a33d$var$ProductDescriptionAndContent = ({ product: product })=>{
    const [isDescriptionExpanded, setIsDescriptionExpanded] = (0, $dvPqk.useState)(false);
    const [isTruncatable, setIsTruncatable] = (0, $dvPqk.useState)(false);
    const descriptionRef = (0, $dvPqk.useRef)(null);
    (0, $dvPqk.useEffect)(()=>{
        const el = descriptionRef.current;
        if (el) {
            const isClamped = el.scrollHeight > el.clientHeight + 1;
            setIsTruncatable(isClamped);
        }
    }, [
        product.description
    ]);
    const handleClick = (event)=>{
        const button = event.target;
        setIsDescriptionExpanded((prev)=>!prev);
        if (button.textContent) (0, $6fuyt.sendButtonClick)(button.textContent);
    };
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7YWoO.Fragment), {
        children: /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $3lzdj.Grid), {
            cols: 12,
            gap: 2,
            children: [
                !(0, (/*@__PURE__*/$parcel$interopDefault($77puL)))(product.description) && /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $3lzdj.Grid).Col, {
                    span: {
                        base: 12,
                        lg: 4
                    },
                    className: "tw-mr-4 md:tw-p-0 tw-pb-6",
                    children: [
                        /*#__PURE__*/ (0, $7YWoO.jsx)("h3", {
                            className: "tw-text-base",
                            children: "Beskrivelse"
                        }),
                        /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                            className: "tw-relative",
                            children: [
                                /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                    ref: descriptionRef,
                                    className: `tw-transition-all ${isDescriptionExpanded ? "" : "tw-line-clamp-4 tw-overflow-hidden"}`,
                                    children: /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                        className: "tw-m-0 tw-text-sm",
                                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $agWqs.Interweave), {
                                            content: product.description?.toString() || ""
                                        })
                                    })
                                }),
                                isTruncatable && /*#__PURE__*/ (0, $7YWoO.jsx)("button", {
                                    type: "button",
                                    onClick: (button)=>handleClick(button),
                                    className: "tw-mt-2 tw-font-semibold hover:tw-underline tw-text-sm",
                                    children: isDescriptionExpanded ? "Les mindre" : "Les mer"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $3lzdj.Grid).Col, {
                    span: {
                        base: 12,
                        lg: 8
                    },
                    children: [
                        !!product.ingredients && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $eYDe5.Accordion), {
                            label: "Ingredienser",
                            variant: "compact",
                            className: "tw-max-w-[1000px]",
                            iconPosition: "right",
                            onClick: ()=>(0, $6fuyt.sendAccordionClick)("Ingredienser"),
                            children: /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $agWqs.Interweave), {
                                    content: product.ingredients?.toString() || ""
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7YWoO.jsx)((0, $eYDe5.Accordion), {
                            label: "Produktinformasjon",
                            variant: "compact",
                            className: "tw-max-w-[1000px]",
                            iconPosition: "right",
                            onClick: ()=>(0, $6fuyt.sendAccordionClick)("Produktinformasjon"),
                            children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $gzL3Z.default), {
                                product: product
                            })
                        }),
                        !(0, (/*@__PURE__*/$parcel$interopDefault($77puL)))(product?.allergens) && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $eYDe5.Accordion), {
                            label: "Allergener",
                            variant: "compact",
                            className: "tw-max-w-[1000px]",
                            iconPosition: "right",
                            onClick: ()=>(0, $6fuyt.sendAccordionClick)("Allergener"),
                            children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cp7HX.AllergensDisplay), {
                                product: product
                            })
                        }),
                        product.nutritions && product.nutritions.length > 0 && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $eYDe5.Accordion), {
                            label: `N\xe6ringsinnhold ${(0, $5OqMf.translateNutritionBaseUnit)(product.nutritionBaseUnit)}`,
                            variant: "compact",
                            className: "tw-max-w-[1000px] !tw-border-ink-border-subtle",
                            iconPosition: "right",
                            onClick: ()=>(0, $6fuyt.sendAccordionClick)("N\xe6ringsinnhold"),
                            children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $1ucql.default), {
                                nutrition: product.nutritions
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $8324848bce55a33d$export$2e2bcd8739ae039 = (0, $lp3dk.view)($8324848bce55a33d$var$ProductDescriptionAndContent);

});
parcelRegister("gzL3Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf7ae69bf53f1014$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $lp3dk = parcelRequire("lp3dk");

var $aQzCo = parcelRequire("aQzCo");

var $jf2w9 = parcelRequire("jf2w9");

var $5LjUB = parcelRequire("5LjUB");

var $bEEBX = parcelRequire("bEEBX");

var $gyNqR = parcelRequire("gyNqR");

var $5OqMf = parcelRequire("5OqMf");

var $BjdTh = parcelRequire("BjdTh");
const $bf7ae69bf53f1014$var$DataRow = (0, $lp3dk.view)(({ name: name, value: value, showAsEan: showAsEan = false })=>{
    if ((0, $bEEBX.default)(value) || (0, $5LjUB.default)(value)) return null;
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: "tw-mb-2 tw-flex tw-justify-between last:tw-border-0 tw-border-b tw-border-solid tw-border-ink-border-subtle tw-pb-2",
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                children: name
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "tw-text-end",
                children: showAsEan ? (0, $5OqMf.formatEan)(value) : value
            })
        ]
    });
});
const $bf7ae69bf53f1014$var$formatWeight = (weight, locale)=>{
    if (!(0, $aQzCo.default)(weight) || weight === 0) return null;
    if (weight > 1.0) return `${weight.toLocaleString(locale)} kg`;
    return `${(weight * 1000).toFixed(0)} g`;
};
const $bf7ae69bf53f1014$var$ProductInfo = ({ product: product })=>{
    const locale = (0, $BjdTh.default)();
    let brand = product.brand;
    if ((0, $gyNqR.default)(brand) && brand.indexOf(",") !== -1) brand = brand.split(",")[1];
    const eanD = (0, $jf2w9.default)(product.eans, {
        packaging: "D"
    })?.code;
    const eanSTK = (0, $jf2w9.default)(product.eans, {
        packaging: "STK"
    })?.code;
    const weight = $bf7ae69bf53f1014$var$formatWeight(product.weight, locale);
    const minShelfLife = product.preservable && `${product.preservable} ${product.preservable === "1" ? "dag" : "dager"}`;
    const amount = product.unit === "STK" || (0, $bEEBX.default)(product?.conversionFactor) || !(0, $aQzCo.default)(product.conversionFactor) ? 1 : product.conversionFactor;
    const baseUnit = (0, $5OqMf.translateBaseUnit)(product.baseUnit, amount);
    const itemsPerPack = `${amount.toFixed(0)} ${baseUnit}`;
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)($bf7ae69bf53f1014$var$DataRow, {
                name: "Artikkelnr",
                value: product.sku
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)($bf7ae69bf53f1014$var$DataRow, {
                name: "EPD-nummer",
                value: product.epdNumber
            }),
            weight !== "0" && /*#__PURE__*/ (0, $7YWoO.jsx)($bf7ae69bf53f1014$var$DataRow, {
                name: "Vekt",
                value: weight
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)($bf7ae69bf53f1014$var$DataRow, {
                name: "Emballasje",
                value: product.packaging
            }),
            (0, $gyNqR.default)(brand) && /*#__PURE__*/ (0, $7YWoO.jsx)($bf7ae69bf53f1014$var$DataRow, {
                name: "Merkevare",
                value: brand
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)($bf7ae69bf53f1014$var$DataRow, {
                name: "EAN, dist.pakning",
                value: eanD,
                showAsEan: true
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)($bf7ae69bf53f1014$var$DataRow, {
                name: "EAN, forbrukerpakning",
                value: eanSTK,
                showAsEan: true
            }),
            product.recyclingChargeBaseUnit > 0 && /*#__PURE__*/ (0, $7YWoO.jsx)($bf7ae69bf53f1014$var$DataRow, {
                name: "Pant",
                value: (0, $5OqMf.formatPrice)(product.recyclingChargeBaseUnit)
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)($bf7ae69bf53f1014$var$DataRow, {
                name: "Minimum restholdbarhet til detaljist",
                value: minShelfLife
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)($bf7ae69bf53f1014$var$DataRow, {
                name: "Ant. i dist.pakning",
                value: itemsPerPack
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)($bf7ae69bf53f1014$var$DataRow, {
                name: "Oppbevaring",
                value: product.storage
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)($bf7ae69bf53f1014$var$DataRow, {
                name: "Opprinnelsesland",
                value: product.countryOfOrigin
            })
        ]
    });
};
var $bf7ae69bf53f1014$export$2e2bcd8739ae039 = (0, $lp3dk.view)($bf7ae69bf53f1014$var$ProductInfo);

});

parcelRegister("1ucql", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbb298858868be32$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $lp3dk = parcelRequire("lp3dk");

var $2z91A = parcelRequire("2z91A");

var $hiPZD = parcelRequire("hiPZD");
const $fbb298858868be32$var$NutritionWrapper = ({ nutrition: nutrition })=>{
    if (nutrition.length === 0) return null;
    if ((0, $2z91A.isProductNutrition)(nutrition)) {
        if (nutrition.length === 1) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hiPZD.default), {
            data: nutrition[0].productNutritions
        });
        return nutrition.map((product)=>/*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h4", {
                        children: product.productName
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hiPZD.default), {
                        data: product.productNutritions
                    })
                ]
            }, product.productName));
    }
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hiPZD.default), {
        data: nutrition
    });
};
var $fbb298858868be32$export$2e2bcd8739ae039 = (0, $lp3dk.view)($fbb298858868be32$var$NutritionWrapper);

});
parcelRegister("hiPZD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8bc19b19608335d0$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $lp3dk = parcelRequire("lp3dk");
const $8bc19b19608335d0$var$NutritionLines = ({ data: data })=>/*#__PURE__*/ (0, $7YWoO.jsx)((0, $7YWoO.Fragment), {
        children: !!data && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
            className: "tw-mb-6",
            children: data.map((r, i)=>/*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                    className: "tw-mb-2 tw-pb-2 tw-flex tw-justify-between last:tw-border-0 tw-border-b tw-border-ink-border-subtle tw-border-solid",
                    children: [
                        /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                            className: `${r.name.startsWith("-") ? "tw-pl-3" : ""}`,
                            children: r.name
                        }),
                        /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                            className: "tw-text-end",
                            children: r.value
                        })
                    ]
                }, r.name + (i + 1)))
        })
    });
var $8bc19b19608335d0$export$2e2bcd8739ae039 = (0, $lp3dk.view)($8bc19b19608335d0$var$NutritionLines);

});



parcelRegister("18kth", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $105397851fccb60b$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $jLK7B = parcelRequire("jLK7B");

var $lp3dk = parcelRequire("lp3dk");

var $bEEBX = parcelRequire("bEEBX");

var $dvPqk = parcelRequire("dvPqk");

var $g9Bxb = parcelRequire("g9Bxb");

var $6fuyt = parcelRequire("6fuyt");

var $5qbUf = parcelRequire("5qbUf");

var $aRSTV = parcelRequire("aRSTV");

var $f7kjZ = parcelRequire("f7kjZ");

var $i6TQx = parcelRequire("i6TQx");

var $hFzdq = parcelRequire("hFzdq");

var $h5LDr = parcelRequire("h5LDr");

var $bO7t0 = parcelRequire("bO7t0");

var $03mes = parcelRequire("03mes");

var $isIf6 = parcelRequire("isIf6");
const $105397851fccb60b$var$listName = "Produktdetaljside";
const $105397851fccb60b$var$productSearchDomain = (0, $isIf6.default).searchConfig.searchDomains.find((searchDomain)=>searchDomain.type === "product");
const $105397851fccb60b$var$algoliaIndex = $105397851fccb60b$var$productSearchDomain?.indexName;
const $105397851fccb60b$var$ProductDetailsImage = ({ product: product })=>{
    const imageRef = (0, $dvPqk.useRef)(null);
    const [imgLoading, setImageLoading] = (0, $dvPqk.useState)(true);
    const [showSpinner, setShowSpinner] = (0, $dvPqk.useState)(false);
    const spinnerDelayRef = (0, $dvPqk.useRef)(null);
    const listInformation = {
        type: (0, $aRSTV.LIST_TYPE).CATEGORY,
        name: $105397851fccb60b$var$listName,
        length: 1
    };
    (0, $dvPqk.useEffect)(()=>{
        setImageLoading(true);
        setShowSpinner(false);
        spinnerDelayRef.current = setTimeout(()=>{
            setShowSpinner(true);
        }, 300);
        if (!(0, $bEEBX.default)(product)) {
            (0, $6fuyt.queueImpression)(product, $105397851fccb60b$var$listName, 1);
            if ($105397851fccb60b$var$algoliaIndex) (0, $hFzdq.default).reportDetailsViewed(product.sku, $105397851fccb60b$var$algoliaIndex);
        }
        return ()=>{
            if (spinnerDelayRef.current) clearTimeout(spinnerDelayRef.current);
        };
    }, [
        product
    ]);
    const handleImageLoad = ()=>{
        setImageLoading(false);
        setShowSpinner(false);
        if (spinnerDelayRef.current) clearTimeout(spinnerDelayRef.current);
    };
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "tw-h-full tw-w-full tw-items-center tw-justify-center",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                        className: "tw-absolute tw-right-0 tw-flex tw-flex-col tw-items-center",
                        children: [
                            !product.expired && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $bO7t0.default), {
                                sku: product.sku,
                                listInformation: listInformation,
                                position: 1
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $h5LDr.default), {
                                badges: product.badges,
                                page: (0, $5qbUf.PageType).ProductDetailsPage
                            })
                        ]
                    }),
                    showSpinner && imgLoading && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: "tw-flex tw-size-full tw-items-center tw-justify-center",
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $jLK7B.default), {
                            className: "tw-animate-spin tw-h-8"
                        })
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: `tw-flex tw-w-full tw-items-center tw-justify-center ${imgLoading ? "tw-hidden" : ""}`,
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)("img", {
                            ref: imageRef,
                            alt: `Produktbilde av ${product.name}`,
                            src: (0, $g9Bxb.productImageUrl)(product.sku, 380),
                            onLoad: handleImageLoad,
                            className: "tw-mx-auto tw-block tw-w-full tw-max-w-40 md:tw-max-w-60"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $03mes.default), {
                labels: product.labels,
                page: (0, $5qbUf.PageType).ProductDetailsPage
            }),
            (0, $i6TQx.default).getPromotionsBySku(product.sku).map((promotion)=>/*#__PURE__*/ (0, $7YWoO.jsx)((0, $f7kjZ.default), {
                    size: "large",
                    children: promotion.banner
                }, promotion.banner))
        ]
    });
};
var $105397851fccb60b$export$2e2bcd8739ae039 = (0, $lp3dk.view)($105397851fccb60b$var$ProductDetailsImage);

});
parcelRegister("jLK7B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6462eec504b3446$export$2e2bcd8739ae039; });

var $dvPqk = parcelRequire("dvPqk");
function $e6462eec504b3446$var$ArrowPathIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $dvPqk.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $dvPqk.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $dvPqk.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
    }));
}
const $e6462eec504b3446$var$ForwardRef = $dvPqk.forwardRef($e6462eec504b3446$var$ArrowPathIcon);
var $e6462eec504b3446$export$2e2bcd8739ae039 = $e6462eec504b3446$var$ForwardRef;

});


parcelRegister("4Ke1J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $178f8e0846754c2c$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $lp3dk = parcelRequire("lp3dk");

var $ezbi8 = parcelRequire("ezbi8");
var $1A6xS = parcelRequire("1A6xS");

var $bEEBX = parcelRequire("bEEBX");

var $3xOZa = parcelRequire("3xOZa");

var $dvPqk = parcelRequire("dvPqk");

var $6fuyt = parcelRequire("6fuyt");

var $aRSTV = parcelRequire("aRSTV");

var $duLFK = parcelRequire("duLFK");

var $bcbvQ = parcelRequire("bcbvQ");

var $lKrOo = parcelRequire("lKrOo");

var $76PCP = parcelRequire("76PCP");

var $bZiDo = parcelRequire("bZiDo");

var $hFzdq = parcelRequire("hFzdq");

var $a2SqC = parcelRequire("a2SqC");

var $cLLe3 = parcelRequire("cLLe3");

var $9pPHV = parcelRequire("9pPHV");

var $isIf6 = parcelRequire("isIf6");

var $3dLLN = parcelRequire("3dLLN");

var $ioVMT = parcelRequire("ioVMT");

var $gtsdT = parcelRequire("gtsdT");

var $5OqMf = parcelRequire("5OqMf");

var $3muLR = parcelRequire("3muLR");

var $luszM = parcelRequire("luszM");

var $9G9jh = parcelRequire("9G9jh");

var $keKqJ = parcelRequire("keKqJ");

var $hrGC2 = parcelRequire("hrGC2");
const $178f8e0846754c2c$var$listName = "Produktdetaljside";
const $178f8e0846754c2c$var$productSearchDomain = (0, $isIf6.default).searchConfig.searchDomains.find((searchDomain)=>searchDomain.type === "product");
const $178f8e0846754c2c$var$algoliaIndex = $178f8e0846754c2c$var$productSearchDomain?.indexName;
const $178f8e0846754c2c$var$ProductDetailsInfo = ({ product: product })=>{
    const imageRef = (0, $dvPqk.useRef)(null);
    const [amount, setAmount] = (0, $dvPqk.useState)(1);
    const listInformation = {
        type: (0, $aRSTV.LIST_TYPE).CATEGORY,
        name: $178f8e0846754c2c$var$listName,
        length: 1
    };
    (0, $dvPqk.useEffect)(()=>{
        if (!(0, $3xOZa.default)(product)) {
            if ((0, $lKrOo.default).is("NOT_LOGGED_IN")) (0, $6fuyt.sendProductDetails)(product);
            else if (!(0, $3xOZa.default)((0, $bZiDo.default).stockLevels[product.sku]) && (0, $duLFK.isDataAvailable)((0, $bZiDo.default).stockLevels[product.sku])) {
                const stock_status_number = (0, $bZiDo.default).stockLevels[product.sku]?.data ?? undefined;
                let stock_status;
                if ((0, $3xOZa.default)(stock_status_number)) stock_status = undefined;
                else if (stock_status_number >= 10) stock_status = "P\xe5 lager";
                else if (stock_status_number > 0) stock_status = "F\xe5 p\xe5 lager";
                else stock_status = "Ikke p\xe5 lager";
                (0, $6fuyt.sendProductDetails)(product, stock_status);
            }
        }
    }, [
        (0, $lKrOo.default).currentState,
        product,
        product && (0, $bZiDo.default).stockLevels[product.sku]?.data
    ]);
    const addToCart = async ()=>{
        if (!(0, $bEEBX.default)(product)) {
            if ((0, $76PCP.default).addToCart(product.sku, amount)) {
                if (!(0, $bEEBX.default)(imageRef)) (0, $a2SqC.default).addFlyingProduct(product.sku, imageRef);
                (0, $6fuyt.sendAddToCart)([
                    {
                        sku: product.sku,
                        qty: amount
                    }
                ], listInformation);
                if ($178f8e0846754c2c$var$algoliaIndex) (0, $hFzdq.default).reportAlgoliaAddToCart(product.sku, $178f8e0846754c2c$var$algoliaIndex);
            } else (0, $gtsdT.logger).warn("cart", "Error occured during add to cart");
        }
    };
    const inStock = 0 !== (0, $bZiDo.default).stockLevels[product.sku]?.data;
    const loggedIn = (0, $bcbvQ.default).isLoggedIn();
    const seasonalProduct = (0, $ioVMT.default)((0, $luszM.SEASONAL_PRODUCTS), product.sku);
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                className: "tw-mb-1",
                children: product.name
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "tw-mb-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                        children: [
                            "Art.nr.: ",
                            product.sku,
                            " ",
                            product.epdNumber && `| EPD: ${product.epdNumber}`
                        ]
                    }),
                    !(0, $bEEBX.default)(product.price) && /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                        className: "tw-flex tw-gap-1",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsxs)("span", {
                                children: [
                                    (0, $5OqMf.formatUnit)(product.unit),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3muLR.default), {
                                product: product
                            })
                        ]
                    })
                ]
            }),
            (0, $isIf6.default).productAvailability.enabled && !product.expired && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $keKqJ.default), {
                product: product
            }),
            loggedIn && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9G9jh.default), {
                product: product
            }),
            !product.expired && /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hrGC2.default), {
                        product: product
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9pPHV.default), {
                        product: product
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3dLLN.default), {
                        product: product
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                        className: "tw-flex md:tw-items-center md:tw-gap-2 tw-gap-4 md:tw-flex-row tw-flex-col",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "tw-flex md:tw-mr-3",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $1A6xS.InputStepper), {
                                    value: amount,
                                    min: 1,
                                    onChange: setAmount
                                }, product.sku)
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "tw-mr-4",
                                children: loggedIn ? /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                                    disabled: !inStock,
                                    variant: "primary",
                                    onClick: addToCart,
                                    size: "regular",
                                    "data-testid": "add-to-cart-product-details-button",
                                    children: inStock ? "Legg i handlekurv" : "Ikke p\xe5 lager"
                                }) : /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                                    variant: "secondary",
                                    onClick: ()=>(0, $a2SqC.default).showLoginModal(),
                                    size: "regular",
                                    children: "Logg inn for kj\xf8p"
                                })
                            })
                        ]
                    })
                ]
            }),
            product.expired && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $ezbi8.Alert), {
                variant: "warning",
                showCloseButton: false,
                children: product.expired && /*#__PURE__*/ (0, $7YWoO.jsx)("span", {
                    children: seasonalProduct ? "Denne varen er utg\xe5tt for sesongen" : "Denne varen er utg\xe5tt fra sortimentet"
                })
            })
        ]
    });
};
var $178f8e0846754c2c$export$2e2bcd8739ae039 = (0, $lp3dk.view)($178f8e0846754c2c$var$ProductDetailsInfo);

});
parcelRegister("3dLLN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4ee3a6a5fce38f3$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $lp3dk = parcelRequire("lp3dk");

var $eAF3Q = parcelRequire("eAF3Q");

var $aQzCo = parcelRequire("aQzCo");

var $5OqMf = parcelRequire("5OqMf");

var $bcbvQ = parcelRequire("bcbvQ");

var $luszM = parcelRequire("luszM");

var $isIf6 = parcelRequire("isIf6");
const $f4ee3a6a5fce38f3$var$DisplayPricePdp = ({ product: product })=>{
    if (!(0, $bcbvQ.default).isLoggedIn()) return null;
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: "tw-pb-2",
        children: [
            (0, $luszM.hasDiscount)(product) && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "tw-mb-2",
                children: /*#__PURE__*/ (0, $7YWoO.jsx)("strong", {
                    className: "tw-line-through tw-opacity-50",
                    children: (0, $5OqMf.formatPrice)(product.priceBeforeDiscount)
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($eAF3Q)))("tw-mb-2", {
                    "tw-text-promotion": (0, $luszM.hasDiscount)(product)
                }),
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("strong", {
                        className: "tw-text-xl",
                        children: (0, $5OqMf.formatPrice)(product.price)
                    }),
                    " ",
                    (0, $5OqMf.formatUnit)(product.unit || "STK", false)
                ]
            }),
            (0, $aQzCo.default)(product.comparisonPrice) && (0, $isIf6.default).showComparisonPrice && !!product.comparisonUnit && /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "tw-mb-2 tw-text-sm",
                children: [
                    (0, $5OqMf.formatPrice)(product.comparisonPrice),
                    " per ",
                    product.comparisonUnit.toLowerCase()
                ]
            })
        ]
    });
};
var $f4ee3a6a5fce38f3$export$2e2bcd8739ae039 = (0, $lp3dk.view)($f4ee3a6a5fce38f3$var$DisplayPricePdp);

});

parcelRegister("9G9jh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9aac5ff68922c9a3$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $lp3dk = parcelRequire("lp3dk");

var $eEIow = parcelRequire("eEIow");

var $jlTfJ = parcelRequire("jlTfJ");
const $9aac5ff68922c9a3$var$ProductWarnings = ({ product: product })=>{
    const warnings = (0, $jlTfJ.default).getCurrentWarnings();
    const filteredProductWarnings = warnings.filter((c)=>c.warningtype?.includes("Produktdetaljsiden for valgte produkter")).filter((c)=>c.skus?.includes(product.sku));
    if (filteredProductWarnings.length === 0) return null;
    return /*#__PURE__*/ (0, $7YWoO.jsx)("aside", {
        className: "tw-mb-3 print:tw-hidden",
        children: filteredProductWarnings.map((warning)=>/*#__PURE__*/ (0, $7YWoO.jsx)((0, $eEIow.default), {
                warning: warning
            }, warning.internalName))
    });
};
var $9aac5ff68922c9a3$export$2e2bcd8739ae039 = (0, $lp3dk.view)($9aac5ff68922c9a3$var$ProductWarnings);

});

parcelRegister("keKqJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c4a53a2b7955def$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $lp3dk = parcelRequire("lp3dk");

var $7FL4g = parcelRequire("7FL4g");

var $gVtxS = parcelRequire("gVtxS");

var $3xOZa = parcelRequire("3xOZa");

var $dvPqk = parcelRequire("dvPqk");

var $bcbvQ = parcelRequire("bcbvQ");

var $bZiDo = parcelRequire("bZiDo");
const $4c4a53a2b7955def$var$StockDisplay = ({ product: product })=>{
    const sku = product.sku;
    const loggedIn = (0, $bcbvQ.default).isLoggedIn();
    (0, $dvPqk.useEffect)(()=>{
        if (loggedIn) (0, $bZiDo.default).checkStockForSku(sku);
    }, [
        sku,
        loggedIn
    ]);
    if (!loggedIn) return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: "tw-mb-6",
        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $gVtxS.Tag), {
            variant: "base",
            icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7FL4g.default), {}),
            children: "Logg inn for \xe5 se tilgjengelighet"
        })
    });
    if ((0, $3xOZa.default)((0, $bZiDo.default).stockLevels[sku])) return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {});
    const level = (0, $bZiDo.default).stockLevels[sku].data;
    if (level === null) return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: "tw-mb-6",
        "data-testid": "check-stock-tag",
        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $gVtxS.Tag), {
            variant: "base",
            children: "Sjekker lagerbeholdning..."
        })
    });
    if (level >= 10) return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: "tw-mb-6",
        "data-testid": "stock-tag",
        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $gVtxS.Tag), {
            variant: "success",
            icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7FL4g.default), {}),
            children: "P\xe5 lager"
        })
    });
    if (level > 0 && level < 10) return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: "tw-mb-6",
        "data-testid": "stock-tag",
        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $gVtxS.Tag), {
            variant: "warning",
            icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7FL4g.default), {}),
            children: "F\xe5 p\xe5 lager"
        })
    });
    if (level <= 0) return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: "tw-mb-6",
        "data-testid": "stock-tag",
        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $gVtxS.Tag), {
            variant: "error",
            icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7FL4g.default), {}),
            children: "Ikke p\xe5 lager"
        })
    });
};
var $4c4a53a2b7955def$export$2e2bcd8739ae039 = (0, $lp3dk.view)($4c4a53a2b7955def$var$StockDisplay);

});
parcelRegister("7FL4g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5960df714b2524ce$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $5960df714b2524ce$var$SvgDot = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M12.008 21q-3.758 0-6.383-2.617T3 12.008t2.617-6.383T11.992 3t6.383 2.617T21 11.992t-2.617 6.383Q15.765 21 12.008 21"
        })
    }));
var $5960df714b2524ce$export$2e2bcd8739ae039 = $5960df714b2524ce$var$SvgDot;

});


parcelRegister("hrGC2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6cdc9951c1fc97b0$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $lp3dk = parcelRequire("lp3dk");
const $6cdc9951c1fc97b0$var$VariableWeightWarning = ({ product: product })=>{
    if (!product.variableWeight) return null;
    return /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
        className: "tw-mb-3",
        children: "OBS! Dette produktet har variabel vekt. V\xe6r oppmerksom p\xe5 at prisen vil bli justert p\xe5 fakturaen."
    });
};
var $6cdc9951c1fc97b0$export$2e2bcd8739ae039 = (0, $lp3dk.view)($6cdc9951c1fc97b0$var$VariableWeightWarning);

});



parcelRegister("2DkT2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b19321a37281088a$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $lp3dk = parcelRequire("lp3dk");

var $g9Bxb = parcelRequire("g9Bxb");

var $gzL3Z = parcelRequire("gzL3Z");

var $agWqs = parcelRequire("agWqs");

var $5LjUB = parcelRequire("5LjUB");

var $1ucql = parcelRequire("1ucql");

var $cp7HX = parcelRequire("cp7HX");
const $b19321a37281088a$var$ProductDetailsPrint = ({ product: product })=>{
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: "tw-hidden print:tw-block print:tw-grid print:tw-grid-cols-12 print:tw-gap-6 print:tw-pt-16",
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "print:tw-col-span-9",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h1", {
                        className: "print:tw-mb-1",
                        children: product.name
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                        className: "print:tw-mb-6",
                        children: [
                            "Art.nr.: ",
                            product.sku,
                            " ",
                            product.epdNumber ? /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
                                children: [
                                    "| EPD: ",
                                    product.epdNumber
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                            className: "print:tw-mb-4",
                            children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $agWqs.Interweave), {
                                content: product.description?.toString()
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "print:tw-col-span-3 print:tw-items-center",
                children: /*#__PURE__*/ (0, $7YWoO.jsx)("img", {
                    className: "print:tw-mx-auto print:tw-block print:tw-w-full",
                    src: (0, $g9Bxb.productImageUrl)(product.sku, 380),
                    alt: `Produktbilde av ${product.name}`
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "print:tw-col-span-12",
                children: [
                    !!product.ingredients && /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)("h4", {
                                children: "Ingredienser"
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                className: "print:tw-mb-6",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $agWqs.Interweave), {
                                    content: product.ingredients.toString()
                                })
                            })
                        ]
                    }),
                    !(0, $5LjUB.default)(product?.allergens) && /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)("h4", {
                                children: "Allergener"
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                className: "print:tw-mb-4",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cp7HX.AllergensDisplay), {
                                    product: product
                                })
                            })
                        ]
                    })
                ]
            }),
            product.nutritions && product.nutritions.length > 0 && /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "print:tw-col-span-6",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h4", {
                        children: "N\xe6ringsinnhold"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $1ucql.default), {
                        nutrition: product.nutritions
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "print:tw-col-span-6",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h4", {
                        children: "Produktinformasjon"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $gzL3Z.default), {
                        product: product
                    })
                ]
            })
        ]
    });
};
var $b19321a37281088a$export$2e2bcd8739ae039 = (0, $lp3dk.view)($b19321a37281088a$var$ProductDetailsPrint);

});



//# sourceMappingURL=ProductDetailsPage.a6ae7159.js.map
